module.exports = __webpack_public_path__ + "static/media/squash.04b90c5e.jpg";